import(/* webpackMode: "eager" */ "/workspace/apps/web/src/app/(internal)/error.tsx");
